function formatDecimalAsPercentage(decimal: number, fractionDigits = 1): string {
  return `${(decimal * 100).toFixed(fractionDigits)}%`;
}

export default formatDecimalAsPercentage;
